import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment, BASE_URL_SERVICIOS_USUARIOS } from "@env/environment";
import { EstadoSistema } from 'src/app/common/interfaces/estadosistema.interface';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { ToolsService } from '@services/varios/tools.service';

@Injectable({
  providedIn: 'root'
})

export class SistemaService {

  constructor(private readonly router:Router, private readonly authService: AuthService, private readonly toolsService: ToolsService) {}
       
  public async getEstadoSistemaByIdSistema(): Promise<EstadoSistema> {
    const BASE_URL =  BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getEstadoSistemaByIdSistema?idSistema=' + environment.idSistema;
    return await axios.get(BASE_URL, {
      headers: {
        'apiKey': environment.apiKeyCargaUsuarios,
      },
    }).then(resp => {     
      if (resp.data.respuesta == "ok") {
        return resp.data.sistema;
      } else {
        return {} as EstadoSistema;
      }
             
    }).catch(async error => {
      console.log(error);
    });
  }  

  public async updateEstadoSistema(sistema: EstadoSistema): Promise<string> {
    let UsrInfo = this.authService.getUserInfo();
    sistema.idSistema = environment.idSistema;
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/updateEstadoSistema';

    return await axios.post(BASE_URL, sistema, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {      
      return resp.data.respuesta;
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }
}